import SandwichesPL from './Sandwiches.pl.json';
import SandwichesEN from './Sandwiches.en.json';
import SandwichesAR from './Sandwiches.ar.json';

import DishesPL from './Dishes.pl.json';
import DishesEN from './Dishes.en.json';
import DishesAR from './Dishes.ar.json';

import AppetizersPL from './Appetizers.pl.json';
import AppetizersEN from './Appetizers.en.json';
import AppetizersAR from './Appetizers.ar.json';

import DrinksPL from './Drinks.pl.json';
import DrinksEN from './Drinks.en.json';
import DrinksAR from './Drinks.ar.json';


// === Import drink images by brand name ===
// import CocaCola from '../Images/18-Coca-Cola.webp';
// import CocaColaZero from '../Images/19-Coca-Cola-Zero.webp';
// import Fanta from '../Images/20-Fanta.webp';
// import Sprite from '../Images/21-Sprite.webp';
// import Fuzetea from '../Images/22-Fuzetea.webp';
// import SokKappy from '../Images/23-Sok-Kappy.webp';
// import Woda from '../Images/24-Woda.webp';

// Map IDs to corresponding images
const drinkImages = {
  // 18: CocaCola,
  // 19: CocaColaZero,
  // 20: Fanta,
  // 21: Sprite,
  // 22: Fuzetea,
  // 23: SokKappy,
  // 24: Woda,
};

// Attach images dynamically to drink items
const attachDrinkImages = (data) => ({
  ...data,
  items: data.items.map((item) => ({
    ...item,
    image: drinkImages[item.ID] || "",
  })),
});

const menuData = {
  Sandwiches: { pl: SandwichesPL, en: SandwichesEN, ar: SandwichesAR },
  Dishes: { pl: DishesPL, en: DishesEN, ar: DishesAR },
  Appetizers: { pl: AppetizersPL, en: AppetizersEN, ar: AppetizersAR },
  // Drinks: { pl: DrinksPL, en: DrinksEN, ar: DrinksAR }
  Drinks: {
    pl: attachDrinkImages(DrinksPL),
    en: attachDrinkImages(DrinksEN),
    ar: attachDrinkImages(DrinksAR),
  },
};

export default menuData;
